var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Utils, CustomElement, Watch, P, PropertyConverters, Debounce, CustomTypedEvent, CustomElementUtils } from '@pacem/pacem-core';
import { PacemMapAdapterElement, PacemOverlayAdapter, PacemLayerAdapter, PacemMarkerAdapter, PacemShapeAdapter, 
//PacemMapPolylineElement, PacemMapPolygonElement, PacemMapCircleElement, PacemMapOverlayImageElement,
MapUtils, MapEvent } from './types-components';
// namespace Pacem.Components.Maps {
const consts = {
    API_JS: 'https://cdn.jsdelivr.net/npm/leaflet@1.9.4/dist/leaflet.min.js', //'https://unpkg.com/leaflet@1.5.1/dist/leaflet.js',
    API_JS_INTEGRITY: null, //'sha512-GffPMF3RvMeYyc1LWMHtK8EbPv0iNZ8/oTtHPx9/cc2ILxQ+u905qIwdpULaqDkyBKgOaB57QTMg7ztg8Jm2Og==',
    API_CSS: 'https://cdn.jsdelivr.net/npm/leaflet@1.9.4/dist/leaflet.min.css', //'https://unpkg.com/leaflet@1.5.1/dist/leaflet.css',
    API_CSS_INTEGRITY: null // 'sha512-xwE/Az9zrjBIphAcBb3F6JVqxf46+CDLwfLMHloNu6KEQCAWi6HcDUbeOfBIptF7tcCzusKFjFw2yuvEpDL9wQ=='
};
function convertAddress(address) {
    return {
        city: address.city,
        state: address.state,
        provinceCode: address["ISO3166-2-lvl6"]?.split('-')[1],
        province: address.county,
        village: address.village,
        zipCode: address.postcode,
        streetName: address.road,
        houseNumber: address.house_number,
        countryCode: address.country_code?.toUpperCase(),
        country: address.country
    };
}
function convertResponse(r) {
    return { fullAddress: r.display_name, address: convertAddress(r.address), position: { lat: parseFloat(r.lat), lng: parseFloat(r.lon), altitude: null } };
}
class LeafletUtils {
    static toLiteral(bounds) {
        const ne = bounds.getNorthEast(), sw = bounds.getSouthWest();
        return { ne, sw };
    }
    static parseGeocoding(response) {
        if (Utils.isNullOrEmpty(response)) {
            return [];
        }
        return response.map(convertResponse);
    }
    static parseReverseGeocoding(response) {
        if (Utils.isNullOrEmpty(response)) {
            return [];
        }
        return [convertResponse(response)];
    }
}
export const LayerLoadEventName = "layerload";
class LayerLoadEvent extends CustomTypedEvent {
    constructor(layer) {
        super(LayerLoadEventName, layer, { bubbles: true });
    }
}
class PacemLeafletMarkerAdapter extends PacemMarkerAdapter {
    deleteInfoWindow(info, map) {
        info.unbindPopup();
    }
    deleteMarker(marker, map) {
        marker.removeFrom(map);
    }
    getMarkerPosition(marker) {
        return marker.getLatLng();
    }
    buildMarker(item, map) {
        return L.marker(item.position).addTo(map);
    }
    addClickEventListener(marker, map, callback) {
        marker.on('click', callback);
    }
    addDragEventListener(marker, map, callback) {
        marker.on('drag', callback);
    }
    addDragEndEventListener(marker, map, callback) {
        marker.on('dragend', callback);
    }
    setPosition(marker, position) {
        marker.setLatLng(position);
    }
    setIcon(marker, icon) {
        const ctrl = this;
        if (typeof icon === 'string') {
            // icon url only
            ctrl._setIcon(marker, icon);
        }
        else if (!Utils.isNull(icon)) {
            // structured icon
            let options = { iconUrl: icon.url };
            if (!Utils.isNullOrEmpty(icon.size)) {
                Utils.extend(options, {
                    iconSize: [icon.size.width, icon.size.height],
                    iconAnchor: [icon.size.width / 2, icon.size.height],
                    popupAnchor: [0, -icon.size.height]
                });
            }
            if (!Utils.isNullOrEmpty(icon.anchor)) {
                Utils.extend(options, {
                    iconAnchor: [icon.anchor.x, icon.anchor.y]
                });
            }
            ctrl._setIcon(marker, new L.Icon(options));
        }
    }
    setLabel(marker, label) {
        // not available
    }
    setDraggable(marker, draggable) {
        if (draggable === true) {
            marker.dragging.enable();
        }
        else {
            marker.dragging.disable();
        }
    }
    closeInfo(marker) {
        marker.closePopup();
    }
    openInfo(info, content, map, marker) {
        info
            .bindPopup(content /*, { offset: new L.Point( 0,  0) }*/)
            .openPopup();
    }
    buildInfoWindow(item) {
        return this.markers.get(item);
    }
    addCloseClickEventListener(marker, map, callback) {
        marker.on('popupclose', callback);
    }
    setContent(marker, content) {
        const popup = marker.getPopup();
        if (popup && popup.getContent() != content) {
            marker.setPopupContent(content);
        }
    }
    _setIcon(marker, v) {
        // legacy (deprecated)
        if (typeof v === 'string') {
            var icon = { 'iconUrl': v }, size, anchor, popup;
            if ((size = this['size']) && /[\d]+,[\d]+/.test(size)) {
                var ndx = -1;
                var size0 = [parseInt(size.substring(0, (ndx = size.indexOf(',')))), parseInt(size.substring(ndx + 1))];
                Object.assign(icon, { 'iconSize': size0 });
            }
            if ((anchor = this['anchor']) && /[\d]+,[\d]+/.test(anchor)) {
                var ndx = -1;
                var anchor0 = [parseInt(anchor.substring(0, (ndx = anchor.indexOf(',')))), parseInt(anchor.substring(ndx + 1))];
                Object.assign(icon, { 'iconAnchor': anchor0, 'popupAnchor': [0, -anchor0[1]] });
            }
            if ((popup = this['popupAnchor']) && /[\d]+,[\d]+/.test(popup)) {
                var ndx = -1;
                var anchor0 = [parseInt(anchor.substring(0, (ndx = anchor.indexOf(',')))), parseInt(anchor.substring(ndx + 1))];
                Object.assign(icon, { 'popupAnchor': anchor0 });
            }
            marker.setIcon(L.icon(icon));
        }
        // good
        else if (v)
            marker.setIcon(v);
    }
}
class PacemLeafletShapeAdapter extends PacemShapeAdapter {
    addDragStartEventListener(shape, callback) {
        throw new Error("Method not implemented.");
    }
    deleteShape(shape, map) {
        throw new Error("Method not implemented.");
    }
    getShapeBounds(shape) {
        throw new Error("Method not implemented.");
    }
    getShapePosition(obj) {
        throw new Error("Method not implemented.");
    }
    buildShape(item, map) {
        throw new Error("Method not implemented.");
    }
    addClickEventListener(shape, callback) {
        throw new Error("Method not implemented.");
    }
    addDragEventListener(shape, callback) {
        throw new Error("Method not implemented.");
    }
    addDragEndEventListener(shape, callback) {
        throw new Error("Method not implemented.");
    }
    setShape(shape, item) {
        throw new Error("Method not implemented.");
    }
    setEditable(shape, editable) {
        throw new Error("Method not implemented.");
    }
    setDraggable(shape, draggable) {
        throw new Error("Method not implemented.");
    }
}
class PacemLeafletLayerAdapter extends PacemLayerAdapter {
    addLoadEventListener(layer, map, callback) {
        layer.on('load', callback);
    }
    removeLoadEventListener(layer, map, callback) {
        layer.off('load', callback);
    }
    deleteLayer(layer, map) {
        layer.remove();
    }
    buildLayer(item, map) {
        const mode = (item.mode || '').toLowerCase();
        switch (mode) {
            case 'wms':
                return L.tileLayer.wms(item.url, { layers: (item.include || []).join(','), minZoom: item.minZoom, maxZoom: item.maxZoom, transparent: true, format: 'image/png' }).addTo(map);
            default:
                return L.tileLayer(item.url, { tms: mode === 'tms', minZoom: item.minZoom, maxZoom: item.maxZoom }).addTo(map);
        }
    }
}
class PacemLeafletOverlayAdapter extends PacemOverlayAdapter {
    deleteOverlay(overlay, map) {
        throw new Error("Method not implemented.");
    }
    buildOverlay(item, map) {
        throw new Error("Method not implemented.");
    }
    setBounds(item, map, bounds) {
        throw new Error("Method not implemented.");
    }
    updateOverlay(overlay, map, item) {
        throw new Error("Method not implemented.");
    }
}
let PacemLeafletMapAdapterElement = class PacemLeafletMapAdapterElement extends PacemMapAdapterElement {
    constructor() {
        super(...arguments);
        this.#tileLayers = new WeakMap();
        this.tiles = '//{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
        this.attribution = 'Map data © <a href="http://openstreetmap.org">OpenStreetMap</a> contributors';
        this._tileLayerLoadHandler = (evt) => {
            this.dispatchLayerLoadEvent(evt.sourceTarget);
        };
        //#endregion
        this._mapUpdateHandler = (ctrl) => {
            const map = this.getMap(ctrl);
            if (!Utils.isNull(map) && !Utils.isNull(ctrl)) {
                this.updateMapElement(ctrl, map.getCenter(), map.getZoom());
            }
        };
    }
    buildOverlayAdapterFor(map) {
        return new PacemLeafletOverlayAdapter(map, this);
    }
    geocode(address, maxResults) {
        return new PacemNominatimMapGeocoder().geocode(address, maxResults, Utils.lang(this));
    }
    reverseGeocode(latLng, _) {
        return new PacemNominatimMapGeocoder().reverseGeocode(latLng, Utils.lang(this));
    }
    getBounds(ctrl) {
        const nativeMap = this.getMap(ctrl);
        const bounds = nativeMap.getBounds();
        return LeafletUtils.toLiteral(bounds);
    }
    isActive() {
        return true;
    }
    setViewNative(ctrl, options) {
        const map = this.getMap(ctrl);
        if (options.center) {
            map.setView(options.center, options.zoom ?? map.getZoom(), { animate: true });
        }
        else if (typeof options.zoom === 'number') {
            map.setZoom(options.zoom, { animate: true });
        }
    }
    buildMarkerAdapterFor(map) {
        return new PacemLeafletMarkerAdapter(map, this);
    }
    buildShapeAdapterFor(map) {
        return new PacemLeafletShapeAdapter(map, this);
    }
    buildLayerAdapterFor(map) {
        return new PacemLeafletLayerAdapter(map, this);
    }
    #tileLayers;
    snapshot(map, type = 'image/png', quality) {
        return Utils.snapshotElement(map.container.firstElementChild, null, type, quality);
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'tiles':
                for (let map of this.enrolledMaps()) {
                    this._redrawMap(map);
                }
            default:
                for (let map of this.enrolledMaps()) {
                    this.invalidateSize(map);
                }
                break;
        }
    }
    // #region ABSTRACT IMPLEMENTATION
    dispose(ctrl) {
        const { map } = this.tryGetMap(ctrl);
        const tiles = this.#tileLayers.get(ctrl);
        if (tiles) {
            tiles.off('load', this._tileLayerLoadHandler);
        }
        map.clearAllEventListeners();
        this.#tileLayers.delete(ctrl);
    }
    async init(container) {
        await Promise.all([CustomElementUtils.importjs(consts.API_JS, consts.API_JS_INTEGRITY, true),
            CustomElementUtils.importcss(consts.API_CSS, consts.API_CSS_INTEGRITY, true)]);
        const ctrl = container;
        var scale = ctrl.scale;
        var draggable = ctrl.draggable;
        var dblClickZoom = ctrl.doubleClickZoom;
        var kbShortcuts = ctrl.keyboardShortcuts;
        //
        var center = L.latLng(MapUtils.parseCoords(ctrl.center));
        var mapOptions = {
            zoomControl: scale && !Utils.isNullOrEmpty(ctrl.zoomControl),
            scrollWheelZoom: ctrl.mousewheel,
            dragging: draggable,
            doubleClickZoom: !dblClickZoom,
            keyboard: kbShortcuts
        };
        const canvas = ctrl.container;
        const mapElement = document.createElement('div');
        mapElement.style.width = '100%';
        mapElement.style.height = '100%';
        canvas.innerHTML = '';
        canvas.appendChild(mapElement);
        const map = L.map(mapElement, mapOptions);
        ['zoomend', 'moveend'].forEach(evt => {
            map.on(evt, _ => {
                this._idleFiller(ctrl);
                this._mapUpdateHandler(ctrl);
            });
        });
        map.on('load', () => {
            if (scale && ctrl.zoomControl) {
                map.zoomControl.setPosition(ctrl['zoomControl']);
            }
            this._idleFiller(ctrl);
        });
        const tiles = L.tileLayer(this.tiles, { attribution: this.attribution }).addTo(map);
        tiles.on('load', this._tileLayerLoadHandler);
        this.#tileLayers.set(ctrl, tiles);
        // setting now the center and zoom, triggers the "load" event and activates the child-components, if any.
        /*
        LeafletJS docs: Map's "load" Event
        "Fired when the map is initialized (when its center and zoom are set for the first time)."
        (http://leafletjs.com/reference.html#map-events)
        */
        map.setView(center, ctrl.zoom);
        // first-load
        map.once('idle', function () {
            map.fire('resize');
            container.dispatchEvent(new MapEvent("maploaded"));
        });
        // call setView NOW to trigger the load event :(
        const cnt = MapUtils.parseCoords(ctrl.center), xpr = [cnt[0], cnt[1]];
        map.setView(xpr, ctrl.zoom);
        return { map, container: mapElement };
    }
    dispatchLayerLoadEvent(layer) {
        this.dispatchEvent(new LayerLoadEvent(layer));
    }
    invalidateSize(ctrl) {
        if (this.hasMap(ctrl)) {
            const map = this.getMap(ctrl);
            map.invalidateSize();
        }
    }
    _idleFiller(ctrl) {
        if (this.hasMap(ctrl)) {
            const map = this.getMap(ctrl);
            map.fire('idle');
        }
    }
    fitBoundsNative(ctrl, bounds, padding = { top: ctrl.paddingTop || 0, left: ctrl.paddingLeft || 0, right: ctrl.paddingRight || 0, bottom: ctrl.paddingBottom || 0 }) {
        const map = this.getMap(ctrl);
        const pads = { 'paddingTopLeft': new L.Point(padding.left, padding.top), 'paddingBottomRight': new L.Point(padding.right, padding.bottom) };
        const ne = bounds.ne, sw = bounds.sw;
        try {
            map.fitBounds([[ne.lat, ne.lng], [sw.lat, sw.lng]], pads);
        }
        catch (e) {
            throw e;
        }
    }
    ;
    _redrawMap(map) {
        var ctrl = this, tileLayer = ctrl.#tileLayers.get(map);
        ;
        if (!Utils.isNull(ctrl.tiles && tileLayer)) {
            tileLayer.setUrl(ctrl.tiles);
        }
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemLeafletMapAdapterElement.prototype, "tiles", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemLeafletMapAdapterElement.prototype, "attribution", void 0);
__decorate([
    Debounce(500)
], PacemLeafletMapAdapterElement.prototype, "_idleFiller", null);
PacemLeafletMapAdapterElement = __decorate([
    CustomElement({ tagName: P + '-map-adapter-leaflet' })
], PacemLeafletMapAdapterElement);
export { PacemLeafletMapAdapterElement };
//#region geocoders
class PacemNominatimMapGeocoder {
    _buildGeocodeRequest(search, maxResults = 10, language = '') {
        // https://nominatim.openstreetmap.org/search?addressdetails=1&format=json&limit={limit}&accept-language={culture}&q={q}
        const url = 'https://nominatim.openstreetmap.org/search?addressdetails=1&format=json';
        const query = { q: search, limit: '' + maxResults, 'accept-language': language };
        return {
            uri: Utils.URIs.appendQuery(url, query),
            options: {
                mode: 'cors' //, headers: {}
            }
        };
    }
    parseGeocodeResponse(response) {
        return new Promise((resolve, reject) => {
            response.json().then((r) => {
                const retval = LeafletUtils.parseGeocoding(r);
                resolve(retval);
            }, e => reject(e));
        });
    }
    geocode(address, maxResults = 10, language = '') {
        return new Promise((resolve, reject) => {
            const request = this._buildGeocodeRequest(address, maxResults, language);
            return fetch(request.uri, request.options).then(response => {
                if (response.ok) {
                    this.parseGeocodeResponse(response).then(resolve, reject);
                }
                else {
                    reject(response);
                }
            }, e => reject(e));
        });
    }
    reverseGeocode(latLng, language = '') {
        return new Promise((resolve, reject) => {
            const request = this._buildReverseRequest(latLng, language);
            return fetch(request.uri, request.options).then(response => {
                if (response.ok) {
                    this._parseReverseResponse(response).then(resolve, reject);
                }
                else {
                    reject(response);
                }
            }, e => reject(e));
        });
    }
    _buildReverseRequest(position, language = '') {
        // https://nominatim.openstreetmap.org/reverse?addressdetails=1&format=json&accept-language={culture}&lat={lat}&lon={lng}
        const url = 'https://nominatim.openstreetmap.org/reverse?addressdetails=1&format=json';
        const latLng = MapUtils.parseCoords(position);
        const query = {
            lat: '' + latLng[0],
            lon: '' + latLng[1],
            'accept-language': language
        };
        return {
            uri: Utils.URIs.appendQuery(url, query),
            options: {
                mode: 'cors' //, headers: {}
            }
        };
    }
    _parseReverseResponse(response) {
        return new Promise((resolve, reject) => {
            response.json().then((r) => {
                const retval = LeafletUtils.parseReverseGeocoding(r);
                resolve(retval);
            }, e => reject(e));
        });
    }
}
//#endregion
//}
